import React, { FC } from "react";

import { Breadcrumbs as CoreBreadcrumbs, Crumb } from "components";

import { SOURCES_LIST_PAGE } from "constants/routes.constants";

const Breadcrumbs: FC = () => {
  return (
    <CoreBreadcrumbs>
      <Crumb appearance="text" name={SOURCES_LIST_PAGE.name} />
    </CoreBreadcrumbs>
  );
};

export default Breadcrumbs;
